// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CastlevaniaBelmontsCurseSaveAnalyzerController from "./castlevania_belmonts_curse_save_analyzer_controller"
application.register("castlevania-belmonts-curse-save-analyzer", CastlevaniaBelmontsCurseSaveAnalyzerController)

import CatalogListReorderController from "./catalog_list_reorder_controller"
application.register("catalog-list-reorder", CatalogListReorderController)

import ConfirmCheckController from "./confirm_check_controller"
application.register("confirm-check", ConfirmCheckController)

import ContactModalController from "./contact_modal_controller"
application.register("contact-modal", ContactModalController)

import CoverFallbackController from "./cover_fallback_controller"
application.register("cover-fallback", CoverFallbackController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import MetroidPrimeOriginsSaveEditorController from "./metroid_prime_origins_save_editor_controller"
application.register("metroid-prime-origins-save-editor", MetroidPrimeOriginsSaveEditorController)

import NestedLinksController from "./nested_links_controller"
application.register("nested-links", NestedLinksController)

import PlaceholderCycleController from "./placeholder_cycle_controller"
application.register("placeholder-cycle", PlaceholderCycleController)

import RevealMoreController from "./reveal_more_controller"
application.register("reveal-more", RevealMoreController)

import SaveLoaderController from "./save_loader_controller"
application.register("save-loader", SaveLoaderController)

import ScrollToListController from "./scroll_to_list_controller"
application.register("scroll-to-list", ScrollToListController)

import ScrollTopLinkController from "./scroll_top_link_controller"
application.register("scroll-top-link", ScrollTopLinkController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)
